import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSizePipe } from './fileSize.pipe';
import { NewlinePipe } from './newline.pipe';
import { StartCasePipe } from './start-case.pipe';
import { KeyValueArrayFilterPipe } from './key-value-array-filter.pipe';
import { CloudinaryImgPipe } from './cloudinary-img.pipe';
import { GetSizeInfoPipe } from './get-size-info.pipe';
import { TemplateTransformPipe } from './template-transform.pipe';

@NgModule({
  declarations: [
    FileSizePipe,
    NewlinePipe,
    StartCasePipe,
    KeyValueArrayFilterPipe,
    CloudinaryImgPipe,
    GetSizeInfoPipe,
    TemplateTransformPipe,
  ],
  imports: [CommonModule],
  exports: [
    FileSizePipe,
    NewlinePipe,
    StartCasePipe,
    KeyValueArrayFilterPipe,
    CloudinaryImgPipe,
    GetSizeInfoPipe,
    TemplateTransformPipe,
  ],
})
export class PipesModule {}
